import { FaEnvelope, FaInstagram, FaTiktok } from "react-icons/fa";

export default function Contact() {
  return (
    <div className="contact-container">

      <h1 className="contact-title">Contact Us</h1>

      <div className="contact-row">

        {/* EMAIL */}
        <a 
          href="mailto:Sows@leonardeducation.org" 
          className="contact-block"
        >
          <FaEnvelope className="contact-icon-large" />
          <p>Sows@leonardeducation.org</p>
        </a>

        {/* INSTAGRAM */}
        <a 
          href="https://instagram.com/sowscholarship"
          target="_blank"
          rel="noopener noreferrer"
          className="contact-block"
        >
          <FaInstagram className="contact-icon-large" />
          <p>@sowscholarship</p>
        </a>

        {/* TIKTOK */}
        <a 
          href="https://tiktok.com/@thesowsfund"
          target="_blank"
          rel="noopener noreferrer"
          className="contact-block"
        >
          <FaTiktok className="contact-icon-large" />
          <p>@thesowsfund</p>
        </a>

      </div>

    </div>
  );
}
